import React from "react";
import { FadeUp } from "./FadeUp";
import { ComparisonFrame } from "./notell/ComparisonFrame";
import { DefeatedTells } from "./notell/DefeatedTells";
export function NoTellSlider() {
  return <section className="bg-band py-20 md:py-28" aria-labelledby="notell-heading" data-id="element-271" data-mp="2d7f8dg4dhly1">
      <div className="container-x" data-id="element-272" data-mp="2hyf5aldhs40j">
        <FadeUp data-id="element-273" data-mp="2hzqh98h3ci2q">
          <p className="font-mono text-[12px] tracking-[0.14em] text-signal md:text-[13px]" data-id="element-274" data-mp="2i08gmdz1vcev">THE NO-TELL STANDARD</p>
          <h2 id="notell-heading" className="mt-5 font-serif text-[38px] leading-[1] tracking-[-0.02em] text-white sm:text-[clamp(44px,4.6vw,64px)]" data-id="element-275" data-mp="2m2d3mtuztasj">
            <span className="block" data-id="element-276" data-mp="2vz81dajfz75r">If it looks like AI,</span>{" "}
            <em className="block italic text-signal" data-id="element-277" data-mp="30whzrfot6t5q">it doesn't leave the studio.</em>
          </h2>
        </FadeUp>

        <FadeUp className="mt-10 md:mt-12" data-id="element-278" data-mp="11lqk259mr6j6">
          <ComparisonFrame data-id="element-279" data-mp="16jifh99hhas4" />
        </FadeUp>

        <FadeUp className="mt-16 md:mt-20" data-id="element-280" data-mp="16kbbpgatghw0">
          <DefeatedTells data-id="element-281" data-mp="16lcxoftdeosi" />
          <p className="mt-10 font-mono text-[11px] tracking-[0.1em] text-foot md:text-[12px]" data-id="element-282" data-mp="2j7scbdew0b99">
            A DIRECTOR CHECKS EVERY FRAME FOR THE TELLS BEFORE YOU SEE IT.
          </p>
        </FadeUp>
      </div>
    </section>;
}